"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useFindUser = function useFindUser(_ref) {
  var cognitoUser = _ref.cognitoUser;
  return {};
};

var useUpdateUser = function useUpdateUser(_ref2) {
  var cognitoUser = _ref2.cognitoUser;
  return [function () {
    return Promise.resolve(null);
  }];
};

var useCreateUser = function useCreateUser(_ref3) {
  var cognitoUser = _ref3.cognitoUser;
  return [function () {
    return Promise.resolve(null);
  }];
};

var useNotificationPermissions = function useNotificationPermissions(currentUser) {
  return {};
};

var _default = function _default(_ref4) {
  var cognitoUser = _ref4.cognitoUser,
      _ref4$useFindUser = _ref4.useFindUser,
      useFindUser = _ref4$useFindUser === void 0 ? function (_ref5) {
    var cognitoUser = _ref5.cognitoUser;
    return {
      user: cognitoUser
    };
  } : _ref4$useFindUser,
      _ref4$useCreateUser = _ref4.useCreateUser,
      useCreateUser = _ref4$useCreateUser === void 0 ? function (_ref6) {
    var cognitoUser = _ref6.cognitoUser;
    return [function () {
      return Promise.resolve(null);
    }];
  } : _ref4$useCreateUser,
      _ref4$useUpdateUser = _ref4.useUpdateUser,
      useUpdateUser = _ref4$useUpdateUser === void 0 ? function (_ref7) {
    var cognitoUser = _ref7.cognitoUser;
    return [function () {
      return Promise.resolve(null);
    }];
  } : _ref4$useUpdateUser,
      _ref4$useNotification = _ref4.useNotificationPermissions,
      useNotificationPermissions = _ref4$useNotification === void 0 ? function (currentUser) {
    return {};
  } : _ref4$useNotification;

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      currentUser = _useState2[0],
      setCurrentUser = _useState2[1];

  var _useFindUser = useFindUser({
    cognitoUser: cognitoUser
  }),
      loading = _useFindUser.loading,
      error = _useFindUser.error,
      user = _useFindUser.user; // const user = !!users && Array.isArray(users) ? users[0] : users;


  var _useCreateUser = useCreateUser({
    cognitoUser: cognitoUser
  }),
      _useCreateUser2 = _slicedToArray(_useCreateUser, 1),
      _createUser = _useCreateUser2[0];

  var _useUpdateUser = useUpdateUser({
    cognitoUser: cognitoUser
  }),
      _useUpdateUser2 = _slicedToArray(_useUpdateUser, 1),
      _updateUser = _useUpdateUser2[0];

  var memoizedCurrentUser = (0, _react.useMemo)(function () {
    return !!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? _objectSpread({}, currentUser) : currentUser;
  }, [JSON.stringify(currentUser)]);
  useNotificationPermissions(currentUser);
  !!error && console.log("ERROR", error);
  (0, _react.useEffect)(function () {
    !!user && !!cognitoUser && setCurrentUser(_objectSpread(_objectSpread(_objectSpread({}, user), cognitoUser), {}, {
      groups: cognitoUser.signInUserSession.accessToken.payload['cognito:groups'] || []
    }));
  }, [JSON.stringify(user), !!cognitoUser]);
  (0, _react.useEffect)(function () {
    !cognitoUser || !cognitoUser.attributes ? setCurrentUser(null) : !loading && !user ? _createUser().then(function (result) {
      return !result && setCurrentUser(null);
    }) : !loading && !!user ? _updateUser() : console.log(null);
  }, [cognitoUser, !!user, loading]);
  return memoizedCurrentUser;
};

exports["default"] = _default;